"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
// @ts-ignore
const common_1 = require("../../../../common");
const DupliactionErrorPageStyled = styled_components_1.default.div `
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	background-color: var(--color-tur, #3ab2bf);

	.back_home {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 590px;
	}

	.btn_white {
		z-index: 1;
		border: none;
		padding: 50px;
		background-color: var(--color-white, #ffffff);
		p {
			font-size: var(--b-l-medium-font-size, 16px);
		}
	}
`;
exports.ErrorPage = react_1.default.memo(({ message }) => {
    react_1.default.useEffect(() => {
        APP.eventManager.publish('SHOW_LOADING', false);
    }, []);
    return (react_1.default.createElement(DupliactionErrorPageStyled, { className: "empty_data" },
        react_1.default.createElement(common_1.Button, { className: "btn_white lg", text: message })));
});
